<template>
	<div class="modal-card">
		<header class="modal-card-head">
			<p class="modal-card-title">Créer une ligne du temps</p>
		</header>
		<section class="modal-card-body">
            <div v-if="canCreateTimeline">
			     <form method="POST">
                    <!-- Title field -->
                    <b-field label="Titre de la ligne du temps" :type="form.errors.has('title') ? 'is-danger' : ''" :message="form.errors.first('title')">
                        <b-input type="text" v-model="form.title" autofocus maxlength="100" has-counter> </b-input>
                    </b-field>

                    <!-- Description field -->
                    <b-field label="Description de la ligne du temps" :type="form.errors.has('description') ? 'is-danger' : ''" :message="form.errors.first('description')">
                        <b-input type="textarea" v-model="form.description" @keydown.enter.native.prevent maxlength="250" has-counter> </b-input>
                    </b-field>
                </form>
            </div>
            <div v-else>
                <div v-if="! hasSubscription && canStartTrial">
                    <div>
                        <b>Afin de pouvoir créer une ligne du temps, veuillez sélectionner une option ci-dessous:</b>
                    </div>

                    <div class="has-text-centered" v-if="canStartTrial" style="padding-top: 10px;">
                        <button class="button is-primary" @click="activateTrial()" :disabled="trialForm.processing">
                            <i class="fa fa-spinner fa-pulse" v-show="trialForm.processing"></i>
                            &nbsp;
                            <span>Tester gratuitement Commemoria pendant 7 jours</span>
                        </button>
                    </div>

                    <div class="has-text-centered" style="padding-top: 10px;">
                        <a class="button is-primary" href="/subscription">
                            <span>Chosir une formule d'abonnement</span>
                        </a>
                    </div>
                </div>

                <div v-if="! hasSubscription && expiredTrial">
                    <div>
                        <b>Votre période d'essai est terminée. Afin de pouvoir créer une nouvelle ligne du temps, veuillez choisir une formule d'abonnement.</b>
                    </div>

                    <div class="has-text-centered" style="padding-top: 10px;">
                        <a class="button is-primary" href="/subscription">
                            <span>Chosir une formule d'abonnement</span>
                        </a>
                    </div>
                </div>

                <div v-if="hasTrial">
                    <div>
                        <b>Vous avez dépassé le nombre de lignes du temps que vous pouvez créer durant votre période d'essai.</b>
                        <br />
                        Veuillez choisir un abonnement ou supprimer une de vos lignes du temps personnelles pour pouvoir créer une nouvelle ligne du temps.
                    </div>

                    <div class="has-text-centered" style="padding-top: 10px;">
                        <a class="button is-primary" href="/subscription">
                            <span>Chosir une formule d'abonnement</span>
                        </a>
                    </div>
                </div>

                <div v-if="hasSubscription">
                    <div>
                        <b>Vous avez dépassé le nombre de lignes du temps que vous pouvez créer avec votre abonnement actuel.</b>
                        <br />
                        Veuillez mettre à jour votre abonnement ou supprimer une de vos lignes du temps personnelles pour pouvoir créer une nouvelle ligne du temps.
                    </div>

                    <div class="has-text-centered" style="padding-top: 10px;">
                        <a class="button is-primary" href="/subscription">
                            <span>Mettre à jour mon abonnement</span>
                        </a>
                    </div>
                </div>
            </div>
		</section>
		<footer class="modal-card-foot">
            <div class="field">
                <div class="control" v-if="canCreateTimeline">
                    <button class="button is-primary" @click="submit()" :disabled="form.processing">
                        <i class="fa fa-spinner fa-pulse" v-show="form.processing"></i>
                        &nbsp;
                        <span>Créer une ligne du temps</span>
                    </button>
                    <button class="button" type="button" @click="$parent.close()">Annuler</button>
                </div>
                <div class="control" v-else>
                    <button class="button is-primary" @click="$parent.close()">
                        OK
                    </button>
                </div>
            </div>
        </footer>
	</div>
</template>

<script>
import Form from 'form-backend-validation';

export default {
    props: ['authorized', 'events'],
    data() {
        return {
            form: new Form({
                title: '',
                description: '',
                events: []
            }),

            trialForm: new Form({}),

            trialActivated: false,
        }
    },

    computed: {
        hasTrial() {
            return this.$store.state.account.trial == 'active';
        },

        expiredTrial() {
            return this.$store.state.account.trial == 'expired';
        },

        canStartTrial() {
            return this.$store.state.account.trial == 'none';
        },

        hasSubscription() {
            return this.$store.state.account.subscription !== 'none';
        },

        isContextualizationPanelVisible() {
            return this.$store.state.contextualization.panel.visible;
        },

        canCreateTimeline() {
            if (this.trialActivated) {
                return true;
            }

            return this.authorized;
        },

    },
    
    methods: {

        activateTrial() {
            this.trialForm.post('/api/v1/subscriptions')
                .then(response => {
                    this.$store.dispatch('activateTrial');
                    this.$buefy.toast.open({
                        message: 'Votre période d\'essai a été activée',
                        type: 'is-success'
                    });
                    this.trialActivated = true;
                }).catch(response => {

                    this.$buefy.toast.open({
                        message: 'Une erreur s\'est produite',
                        type: 'is-danger'
                    });
        
                });
        },

        submit() {
            if (this.events) {
                this.events.forEach(function (event) {
                    this.form.events.push(event.id);
                }, this);
            }

            this.form.post('/api/v1/timelines').then(response => {
                
                this.$buefy.toast.open({
                    message: 'Votre ligne du temps a été créée',
                    type: 'is-success'
                });

                this.$router.push({ name: 'timelines.show', params: { id: response.id }});

                Bus.$emit('timelines.fetch');

                if (this.isContextualizationPanelVisible) {
                    this.cleanContextualizationTimelines();
                    this.toogleContextualizationPanelStatus();
                }
                
                this.$parent.close();

            }).catch(response => {
                this.$buefy.toast.open({
                    message: 'Une erreur s\'est produite',
                    type: 'is-danger'
                });
            });
        },

        cleanContextualizationTimelines() {
            this.$store.dispatch('cleanContextualizationTimelines');
        },

        toogleContextualizationPanelStatus() {
            this.$store.dispatch('toogleContextualizationPanelStatus');
        }

    },
}

</script>

<style>
</style>
